import React, { useEffect, useState } from "react";
import { Star, Trash2 } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const load = () => api.get("/admin/reviews", { withCredentials: true }).then((r) => setReviews(r.data));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!confirm("Delete this review?")) return;
    try { await api.delete(`/admin/reviews/${id}`, { withCredentials: true }); toast.success("Deleted"); load(); } catch { toast.error("Delete failed"); }
  };

  return (
    <div className="p-8 lg:p-12" data-testid="admin-reviews">
      <p className="label-tiny text-brand-gold">Voice of Customer</p>
      <h1 className="font-serif-brand text-4xl text-brand-charcoal mt-1 mb-8">Reviews · {reviews.length}</h1>

      <div className="grid md:grid-cols-2 gap-4">
        {reviews.map((r) => (
          <div key={r.id} className="border border-brand-gold/25 bg-brand-ivory p-5" data-testid={`review-${r.id}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex gap-0.5">
                {[...Array(r.rating)].map((_, i) => <Star key={i} size={12} fill="#C5A059" strokeWidth={0} />)}
              </div>
              <button onClick={() => del(r.id)} className="p-2 text-brand-charcoal hover:text-brand-maroon" data-testid={`del-review-${r.id}`}><Trash2 size={14} /></button>
            </div>
            <p className="font-serif-brand text-lg text-brand-charcoal">{r.title}</p>
            <p className="text-sm text-brand-muted mt-1">{r.body}</p>
            {r.image_url && <img src={r.image_url} alt="" className="w-full h-32 object-cover mt-3" />}
            <p className="label-tiny text-brand-gold mt-3">— {r.customer_name} · {new Date(r.created_at).toLocaleDateString("en-IN")}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
